import { render, staticRenderFns } from "./BaseSlidePanel.vue?vue&type=template&id=b50e2a54&scoped=true&"
import script from "./BaseSlidePanel.vue?vue&type=script&lang=js&"
export * from "./BaseSlidePanel.vue?vue&type=script&lang=js&"
import style0 from "./BaseSlidePanel.vue?vue&type=style&index=0&id=b50e2a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50e2a54",
  null
  
)

export default component.exports